// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiCommentController from "./ai_comment_controller"
application.register("ai-comment", AiCommentController)

import AsyncSectionController from "./async_section_controller"
application.register("async-section", AsyncSectionController)

import AttachmentPreviewController from "./attachment_preview_controller"
application.register("attachment-preview", AttachmentPreviewController)

import AutoModalController from "./auto_modal_controller"
application.register("auto-modal", AutoModalController)

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import BsTooltipController from "./bs_tooltip_controller"
application.register("bs-tooltip", BsTooltipController)

import ClearMemoController from "./clear_memo_controller"
application.register("clear-memo", ClearMemoController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import FeedbackController from "./feedback_controller"
application.register("feedback", FeedbackController)

import FeedbackChartController from "./feedback_chart_controller"
application.register("feedback-chart", FeedbackChartController)

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)

import CopyJudgmentController from "./copy_judgment_controller"
application.register("copy-judgment", CopyJudgmentController)

import CsvDropzoneController from "./csv_dropzone_controller"
application.register("csv-dropzone", CsvDropzoneController)

import CsvStatusController from "./csv_status_controller"
application.register("csv-status", CsvStatusController)

import CsvTypeController from "./csv_type_controller"
application.register("csv-type", CsvTypeController)

import CsvUploadController from "./csv_upload_controller"
application.register("csv-upload", CsvUploadController)

import DatalistAutocompleteController from "./datalist_autocomplete_controller"
application.register("datalist-autocomplete", DatalistAutocompleteController)

import DeductionWarningController from "./deduction_warning_controller"
application.register("deduction-warning", DeductionWarningController)

import DisableOnSubmitController from "./disable_on_submit_controller"
application.register("disable-on-submit", DisableOnSubmitController)

import DmNotificationsController from "./dm_notifications_controller"
application.register("dm-notifications", DmNotificationsController)

import EmployeeFilterController from "./employee_filter_controller"
application.register("employee-filter", EmployeeFilterController)

import ExampleChipsController from "./example_chips_controller"
application.register("example-chips", ExampleChipsController)

import FieldTipController from "./field_tip_controller"
application.register("field-tip", FieldTipController)

import FieldTooltipController from "./field_tooltip_controller"
application.register("field-tooltip", FieldTooltipController)

import GuestPageChromeController from "./guest_page_chrome_controller"
application.register("guest-page-chrome", GuestPageChromeController)

import HeaderDropdownsController from "./header_dropdowns_controller"
application.register("header-dropdowns", HeaderDropdownsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HyojunhoshuBatchController from "./hyojunhoshu_batch_controller"
application.register("hyojunhoshu-batch", HyojunhoshuBatchController)

import LiasApplicationController from "./lias_application_controller"
application.register("lias-application", LiasApplicationController)

import LiasCommaController from "./lias_comma_controller"
application.register("lias-comma", LiasCommaController)

import LocaleSelectController from "./locale_select_controller"
application.register("locale-select", LocaleSelectController)

import ModalSwitchController from "./modal_switch_controller"
application.register("modal-switch", ModalSwitchController)

import MynumberController from "./mynumber_controller"
application.register("mynumber", MynumberController)

import NameLengthController from "./name_length_controller"
application.register("name-length", NameLengthController)

import NewFieldsController from "./new_fields_controller"
application.register("new-fields", NewFieldsController)

import OnboardingChatLauncherController from "./onboarding_chat_launcher_controller"
application.register("onboarding-chat-launcher", OnboardingChatLauncherController)

import PaidOnEditController from "./paid_on_edit_controller"
application.register("paid-on-edit", PaidOnEditController)

import PayrollStickyController from "./payroll_sticky_controller"
application.register("payroll-sticky", PayrollStickyController)

import PayrollTableController from "./payroll_table_controller"
application.register("payroll-table", PayrollTableController)

import PermissionApprovalModalController from "./permission_approval_modal_controller"
application.register("permission-approval-modal", PermissionApprovalModalController)

import PlanRestrictionModalController from "./plan_restriction_modal_controller"
application.register("plan-restriction-modal", PlanRestrictionModalController)

import PostcodeController from "./postcode_controller"
application.register("postcode", PostcodeController)

import PurchaseRadioCardController from "./purchase_radio_card_controller"
application.register("purchase-radio-card", PurchaseRadioCardController)

import RetireFormController from "./retire_form_controller"
application.register("retire-form", RetireFormController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RoomMessagesController from "./room_messages_controller"
application.register("room-messages", RoomMessagesController)

import RowFocusController from "./row_focus_controller"
application.register("row-focus", RowFocusController)

import SendPayslipModalController from "./send_payslip_modal_controller"
application.register("send-payslip-modal", SendPayslipModalController)

import SuppDrawerController from "./supp_drawer_controller"
application.register("supp-drawer", SuppDrawerController)

import TrialStatusController from "./trial_status_controller"
application.register("trial-status", TrialStatusController)

import TrialStepperController from "./trial_stepper_controller"
application.register("trial-stepper", TrialStepperController)

import TrialSubmitController from "./trial_submit_controller"
application.register("trial-submit", TrialSubmitController)

import YearTabsController from "./year_tabs_controller"
application.register("year-tabs", YearTabsController)
